<template>
    <div class="min-h-8 flex items-center max-w-[50%]" data-testid="widget-title-container">
        <RedesignTruncatedTextTooltip
            v-if="title && showWidgetTitle"
            :text="$te(title) ? $t(title) : title"
            :content-class="['font-semibold widget-header-title', { 'text-lg': !customFontSize }]"
            :content-style="customFontSize"
            test-id="widget-title"
        />
    </div>
</template>
<script>
import get from 'lodash/get'
import { activeLayoutFontSize, showLayoutWidgetTitle } from '@/composables/globalData/useLayouts'
import { isPreviewLayout, widgetPreviewHeaderTextFontSize } from '@/composables/usePreviewLayout'
import { DEFAULT_FONT_SIZE_PX } from '@/enum/default-layout-config'
import RedesignTruncatedTextTooltip from '@/components/RedesignBaseComponents/RedesignTruncatedTextTooltip.vue'

export default {
    name: 'BaseWidgetTitle',
    components: {
        RedesignTruncatedTextTooltip
    },
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    computed: {
        showWidgetTitle () {
            return showLayoutWidgetTitle.value
        },
        customFontSize () {
            const styles = isPreviewLayout.value ? widgetPreviewHeaderTextFontSize.value : activeLayoutFontSize.value
            const fontSize = get(styles, 'fontSize', '')
            if (!styles || fontSize === DEFAULT_FONT_SIZE_PX) {
                return
            }
            return {
                fontSize
            }
        }
    }
}
</script>
